<template>
  <div class="container pt-5 mt-5">
    <div v-if="Orderloading" class="text-center p-5 m-5">
      <sweetalert-icon class="text-center" :icon="loading" />
      <h3>{{ loadingMsg }}</h3>
    </div>
    <div class="row" v-else>
      <div class="col-sm-8">
        <div class="card">
          <div
            class="p-3 d-flex justify-content-between"
            style="background-color: #F69325 ; color: #fff"
          >
            <h4>1. Select Address</h4>
            <span role="button" @click="addShowadd()" v-if="addShow == false">
              <i class="fa fa-plus"></i>
            </span>
            <span role="button" @click="addShowadd()" v-if="addShow == true">
              <i class="fa fa-minus"></i>
            </span>
          </div>
          <div v-if="addShow">
            <div v-if="addAddressloading">
              <sweetalert-icon class="text-center" :icon="Loadingtype" />
            </div>
            <div class="card-body" v-else>
              <div>
                <div class="container">
                  <h5 class="text-center">
                    Move marker to adjust your Location
                  </h5>
                </div>
                <gmap-map
                  :center="center"
                  :zoom="12"
                  style="width:100%;  height: 400px;"
                >
                  <div v-if="marker">
                    <gmap-marker
                      :position="marker.position"
                      @click="center = marker.position"
                      :draggable="true"
                      :clickable="true"
                      @drag="updateLocation"
                      @dragend="drgensed"
                    ></gmap-marker>
                  </div>
                </gmap-map>
              </div>

              <b-form class="row" v-on:submit.prevent="AddAddress">
                <div class="col-md-12">
                  <b-form-group label="Address Type:">
                    <b-form-select
                      v-model="address.addressType"
                      :options="addType"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Contact Person:">
                    <b-form-input
                      v-model="address.c_person"
                      type="text"
                      required
                      placeholder="Enter Name of Contact Person"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Mobile Number:">
                    <b-form-input
                      v-model="address.c_number"
                      type="number"
                      required
                      placeholder="10-digit mobile number"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Pincode:">
                    <b-form-input
                      v-model="address.pincode"
                      type="number"
                      required
                      placeholder="Pincode"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="landmark:">
                    <b-form-input
                      v-model="address.landmark"
                      type="text"
                      required
                      placeholder="LandMark"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Addrees First Line:">
                    <b-form-input
                      type="text"
                      v-model="address.firstLine"
                      placeholder="Flat No / Society / Tower"
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Addrees Second Line:">
                    <b-form-input
                      type="text"
                      v-model="address.secondLine"
                      required
                      placeholder="Address (Area and Street)"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="City:">
                    <b-form-input
                      v-model="address.city"
                      type="text"
                      required
                      placeholder="City / District / Town "
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="State:">
                    <b-form-select
                      v-model="address.state"
                      :options="statelist"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-6 ">
                  <button type="submit" class="btn btn-success btn-lg">
                    Save
                  </button>
                </div>
              </b-form>
            </div>
          </div>
          <div
            class="row p-3"
            v-else
            v-for="(address, index) in customerAdr"
            :key="index"
          >
            <div class="container-fluid">
              <div class="row">
                <div class="col">
                  <span
                    class="badge"
                    style="background-color: #F69325 ; color: #fff"
                    >{{ address.addressType }}</span
                  >
                  <input
                    type="radio"
                    :style="{
                      width: '20px',
                      height: '20px',
                      marginLeft:
                        address.addressType === 'Home' ? '110px' : '40px'
                    }"
                    v-model="selectedAdr"
                    :value="address.id"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>
                    {{ address.firstLine }},{{ address.secondLine }},{{
                      address.landmark
                    }},{{ address.city }},{{ address.state }},{{
                      address.pincode
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="p-3" style="background-color: #F69325 ; color: #fff">
              <h4>2. Order Summary</h4>
            </div>
            <div v-for="(cartPro, index) in carts" :key="index">
              <div class="row">
                <div class="p-4 col">
                  <img
                    :src="getProduct(cartPro.productId, 'image')"
                    width="100px"
                    height="100px"
                  />
                </div>
                <div class="p-4 col">
                  <div>
                    <strong>{{ getProduct(cartPro.productId, "name") }}</strong>
                  </div>
                  <span class="mb-2">
                    Sold By
                    <router-link
                      :to="
                        '/vendorProfile/' +
                          getVendorProduct(cartPro.vendorProductId, 'vendorId')
                      "
                      >{{
                        getSellerName(
                          getVendorProduct(cartPro.vendorProductId, "vendorId")
                        )
                      }}</router-link
                    >
                  </span>
                  <div>
                    {{ getVendorProduct(cartPro.vendorProductId, "sellprice") }}
                    x {{ cartPro.qty
                    }}{{ getProduct(cartPro.productId, "unitType") }}
                  </div>
                </div>
                <div class="p-4 col text-danger">
                  {{
                    getPriceChangeStockDetails(cartPro)
                      ? null
                      : "Item is out of stock remove it to checkout"
                  }}
                </div>
              </div>
              <div class="row">
                <div class="p-4 col">
                  <span class="d-flex">
                    <i
                      class="btn btn-sm btn-circle fa fa-minus"
                      style="background-color:#D0D0D2; color:#1A1824;"
                      @click="
                        addToCart(
                          cartPro.vendorProductId,
                          cartPro.productId,
                          cartPro.qty,
                          getProduct(cartPro.productId, 'unitType'),
                          getVendorProduct(
                            cartPro.vendorProductId,
                            'sellprice'
                          ),
                          'minus',
                          user.uid,
                          cartPro.vendorId
                        );
                        StockCheck = true;
                      "
                    ></i>
                    <span class="p-1">
                      {{ cartPro.qty }}
                      {{ getProduct(cartPro.productId, "unitType") }}
                    </span>
                    <i
                      class="btn btn-sm btn-circle fa fa-plus"
                      style="background-color:#F69325 ; color:#FFFFFF;"
                      @click="
                        addToCart(
                          cartPro.vendorProductId,
                          cartPro.productId,
                          cartPro.qty,
                          getProduct(cartPro.productId, 'unitType'),
                          getVendorProduct(
                            cartPro.vendorProductId,
                            'sellprice'
                          ),
                          'plus',
                          user.uid,
                          cartPro.vendorId
                        );
                        StockCheck = true;
                      "
                    ></i>
                  </span>
                </div>
                <div class="p-4 col">
                  <span
                    class="p-4"
                    style="color: #F69325 ; border-top: 2px solid #F69325 "
                    >₹ {{ cartPro.price }}</span
                  >
                </div>
                <div class="p-4 col">
                  <span
                    role="button"
                    class="btn"
                    style="background-color: #F69325 ; color: #fff"
                    @click="RemoveProduct(cartPro.vendorProductId)"
                    >Remove</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="p-3" style="background-color: #F69325 ; color: #fff">
              <h4>3. Payment options</h4>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="row p-4">
                  <div class="col-md-6 row">
                    <div class="col-md-2">
                      <img
                        src="../assets/online.svg"
                        style="height:40px"
                        alt=""
                      />
                    </div>
                    <div class="col">
                      <span>Aamcart Balance</span>
                      <span class="ml-4 pt-5">
                        <input
                          type="checkbox"
                          v-model="aamcartBalanceUse"
                          @click="UseAamcartBalance"
                          style="width: 20px; height: 20px"
                        />
                        <p style="font-size:12px">
                          Available Balance
                          <span class="badge badge-success">{{
                            wallet.txnAamcartBalance
                          }}</span>
                        </p>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6 row">
                    <div class="col-md-2">
                      <img
                        src="../assets/ofline.svg"
                        style="height:40px"
                        alt=""
                      />
                    </div>
                    <div class="col">
                      <span>Reward Balance</span>
                      <span class="ml-4 pt-5">
                        <input
                          type="checkbox"
                          v-model="rewardBalanceUse"
                          @click="UseRewardBalance"
                          style="width: 20px; height: 20px"
                        />
                        <p style="font-size:12px">
                          Redeem Balance
                          <span class="badge badge-success">
                            <span
                              v-if="
                                (rewardAmount / 100) * getCartTotalPrice() <
                                  wallet.txnRewardsBalance
                              "
                            >
                              {{
                                (
                                  (rewardAmount / 100) *
                                  getCartTotalPrice()
                                ).toFixed(1)
                              }}
                            </span>
                            <span v-else>
                              {{ wallet.txnRewardsBalance }}
                            </span>
                          </span>
                          <br />
                          <span
                            v-if="
                              (rewardAmount / 100) * getCartTotalPrice() <
                                wallet.txnRewardsBalance
                            "
                          >
                            Available Balance
                            <span class="badge badge-danger">
                              <del>
                                {{ wallet.txnRewardsBalance.toFixed(1) }}</del
                              >
                            </span>
                          </span>
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row p-4">
                  <div class="col-md-6 row">
                    <div class="col-md-2">
                      <img
                        src="../assets/online.svg"
                        style="height:40px"
                        alt=""
                      />
                    </div>

                    <div class="col">
                      <span>Online Payment</span>
                      <span class="ml-4 pt-5">
                        <input
                          type="radio"
                          v-model="PaymentMode"
                          :disabled="!onlinePayment"
                          style="width: 20px; height: 20px"
                          value="Online"
                        />
                        <p style="font-size:12px">
                          Supports UPI, Google pay, Debit or Credit Card,
                          PhonePe, Paytm Wallet
                        </p>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6 row">
                    <div class="col-md-2">
                      <img
                        src="../assets/ofline.svg"
                        style="height:40px"
                        alt=""
                      />
                    </div>
                    <div class="col">
                      <span>COD</span>
                      <span class="ml-4 pt-5">
                        <input
                          type="radio"
                          v-model="PaymentMode"
                          value="COD"
                          style="width: 20px; height: 20px"
                        />
                      </span>
                      <p style="font-size:12px">
                        Collect on Delivery, Using Any Debit or Creadit Card,
                        and Cash
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-4 custom-pos">
        <div class="card" style="background-color: #E7E7E7">
          <div
            class="d-flex pt-2 pb-2 pl-4 pr-4"
            style="background-color: #3E3E3E"
          >
            <p style="color: #fff">Price Details</p>
          </div>
          <div class="row p-2 pl-3 pr-3">
            <div class="col" style="color: #000000">
              Price ({{ carts.length }} items)
            </div>
            <div class="col" style="color: #000000">
              ₹ {{ getCartTotalPrice() }}
            </div>
          </div>
          <div class="row p-2 pl-3 pr-3">
            <div class="col" style="color: #000000">
              Delivery Charge
            </div>
            <div class="col" style="color: #000000">₹ {{ deliveryCharge }}</div>
          </div>
          <div class="row p-2 pl-3 pr-3" v-if="useAmmount.aamcartamount > 0">
            <div class="col" style="color: #000000">
              Aamcart Wallet
            </div>
            <div class="col" style="color: #000000">
              ₹ -{{ useAmmount.aamcartamount }}
            </div>
          </div>
          <div class="row p-2 pl-3 pr-3" v-if="useAmmount.rewardsamount > 0">
            <div class="col" style="color: #000000">
              Reward Wallet
            </div>
            <div class="col" style="color: #000000">
              ₹ -{{ useAmmount.rewardsamount }}
            </div>
          </div>
          <div class="row p-2 pl-3 pr-3" v-if="couponfound === 'yes'">
            <div class="col" style="color: #000000">
              {{ coupontype }}
              <b-badge
                v-if="coupontype === 'Coupon'"
                variant="primary"
                style="padding:8px"
                >{{ couponValue }}%</b-badge
              >
              <b-badge
                v-if="coupontype === 'CashBack'"
                variant="primary"
                style="padding:8px"
                >₹{{ couponValue }}</b-badge
              >
            </div>
            <div
              class="col"
              style="color: #000000"
              v-if="coupontype === 'Coupon'"
            >
              ₹ {{ (getCartTotalPrice() * couponValue) / 100 }}
            </div>
            <div
              class="col"
              style="color: #000000"
              v-if="coupontype === 'CashBack'"
            >
              ₹ -{{ couponValue }}
            </div>
          </div>
          <div class="row p-3 mr-0 ml-0" style="background-color: #fff">
            <div class="col" style="color: #F69325 ">
              Total Amount
            </div>
            <div class="col" style="color: #F69325 ">
              <span style="font-weight: bold" v-if="!isValid"
                >₹ {{ getCartTotalPrice() + deliveryCharge }}</span
              >
              <span v-if="isValid">₹{{ gettotalafterdiscount() }}</span>
            </div>
          </div>
        </div>
        <b-card class="coupon">
          <p style="color:black">If you have any coupon, enter here -</p>
          <input
            type="text"
            placeholder="COUPON HERE"
            class="in"
            v-model="coupon"
          />
          <button class="btn btn-sm btn-primary ml-3" @click="validate">
            Apply
          </button>
          <div class="mt-2" v-show="couponValue">
            <b-badge
              class="bad"
              v-if="coupontype === 'Coupon'"
              variant="primary"
              >CONGRATULATIONS you got {{ couponValue }}%
              {{ coupontype }}</b-badge
            >
            <b-badge
              class="bad"
              v-if="coupontype === 'CashBack'"
              variant="primary"
              >CONGRATULATIONS you got ₹{{ couponValue }}
              {{ coupontype }}</b-badge
            >
          </div>
          <div class="mt-2" v-if="isExpired">
            <b-badge class="bad" variant="danger"
              >Unfortunately Your coupon has Expired</b-badge
            >
          </div>
          <div class="mt-2" v-if="isEarly">
            <b-badge class="bad" v-if="isEarly" variant="danger"
              >Sorry, but the coupon is YET TO START</b-badge
            >
          </div>
          <div class="mt-2" v-if="notValid">
            <b-badge class="bad" variant="danger"
              >!INVALID Coupon. Please try again.</b-badge
            >
          </div>
        </b-card>
        <div class="p-4">
          <button
            class="btn btn-success btn-custom"
            :disabled="CheckForOrder() || !StockCheck"
            @click="PlaceOrder()"
          >
            Place Your Order
          </button>
        </div>
        <div class="pt-3 text-danger" style="font-size:13px">
          <span v-if="selectedAdr == null">
            Select Address For Place Order
          </span>
          <br />
          <span v-if="PaymentMode == null"> Required Payment Method </span
          ><br />
          <span v-show="!StockCheck">
            Please remove Unstocked Item
          </span>
          <span v-show="!carts.length">
            Please Add Product into Cart
          </span>
        </div>
      </div>
    </div>
    <div class="container" v-html="info.data" id="payment"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dbFs, db, updateWallet } from "@/modules/database";
import router from "@/modules/router";
import { addToCart } from "../modules/cart";
import axios from "axios";

export default {
  data() {
    return {
      notValid: false,
      isExpired: false,
      isEarly: false,
      couponid: "",
      discountedPrice: 0,
      couponfound: "",
      coupon: "",
      couponValue: "",
      isValid: false,
      center: { lat: 28.5355, lng: 77.391 },
      marker: null,
      selectedAddress: null,
      StockCheck: true,
      Orderloading: false,
      Loadingtype: "loading",
      loading: "loading",
      totalAmount: "500",
      loadingMsg: "",
      selectedAdr: null,
      PaymentMode: null,
      PaymentModeTxn: "",
      PlaceOrderError: true,
      customerAdr: [],
      useAmmount: {
        rewardsamount: 0,
        aamcartamount: 0
      },
      deliveryCharge: 50,
      onlinePayment: false,
      rewardAmount: 0,
      aamcartBalanceUse: false,
      rewardBalanceUse: false,
      carts: [],
      visible: true,
      addAddressloading: false,
      products: [],
      vendorProducts: [],
      vendors: [],
      addShow: false,
      address: {
        addressType: null,
        c_number: "",
        c_person: "",
        city: "",
        firstLine: "",
        landmark: "",
        status: true,
        latlng: { lat: 0, lng: 0 },
        pincode: "",
        secondLine: "",
        state: null
      },
      VendorsList: [],
      info: {
        data: ""
      },
      statelist: [
        {
          value: null,
          text: "Select State"
        },
        {
          value: "Delhi NCR",
          text: "Delhi NCR"
        }
      ],
      addType: [
        {
          value: null,
          text: "Select Address Type"
        },
        {
          value: "Home",
          text: "Home"
        },
        {
          value: "Office/Commercial	",
          text: "Office/Commercial	"
        }
      ],
      OrderId: "",
      options: [{ value: 0, text: "Coupon" }, { value: 1, text: "CashBack" }],
      coupontype: "",
      location: {
        latitude: "",
        longitude: ""
      },
      appConfig: null,
      wallet: []
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  mounted() {
    this.setupFirebaseReading();
    this.getAllVendor();
    this.geolocate();
    this.getWallet();
    let allCharacters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 10; i++) {
      result += allCharacters.charAt(~~(Math.random() * allCharacters.length));
    }
    this.OrderId = result;
  },
  methods: {
    getWallet() {
      this.loading = true;
      this.$bind("wallet", dbFs.collection("wallet").doc(this.user.uid))
        .then(() => {
          if (!this.wallet) {
            let walletData = {
              txnRewardsBalance: 0
            };
            dbFs
              .collection("wallet")
              .doc(this.user.uid)
              .set(walletData, { merge: true });
          }
          if (!this.wallet) {
            let walletData = {
              txnAamcartBalance: 0
            };
            dbFs
              .collection("wallet")
              .doc(this.user.uid)
              .set(walletData, { merge: true });
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validate() {
      dbFs
        .collection("coupon")
        .where("code", "==", this.coupon)
        .get()
        .then(res => {
          if (res.empty) {
            this.couponfound = "no";
            this.isValid = false;
            this.isExpired = false;
            this.isEarly = false;
            this.notValid = true;
            this.couponid = "";
            this.couponValue = "";
            this.coupontype = "";
          } else {
            res.forEach(doc => {
              var data = doc.data();
              // Validating date
              var today = new Date().getTime();
              if (today > data.valid_from && today < data.valid_end) {
                this.couponid = doc.id;
                this.couponValue = data.value;
                this.options.forEach(ele => {
                  if (ele.value === data.type) {
                    this.coupontype = ele.text;
                  }
                });
                this.isValid = true;
                this.isExpired = false;
                this.isEarly = false;
                this.couponfound = "yes";
                this.notvalid = false;
              } else {
                this.couponid = "";
                this.couponValue = "";
                this.coupontype = "";
                this.isValid = false;
              }
              if (today > data.valid_end) {
                this.couponid = "";
                this.couponValue = "";
                this.coupontype = "";
                this.isValid = false;
                this.isExpired = true;
                this.isEarly = false;
                this.couponfound = "no";
                this.notvalid = false;
              } else if (today < data.valid_from) {
                this.couponid = "";
                this.couponValue = "";
                this.coupontype = "";
                this.isValid = false;
                this.isEarly = true;
                this.isExpired = false;
                this.couponfound = "no";
                this.notvalid = false;
              }
            });
            this.notValid = false;
          }
        })
        .catch(() => {
          console.log("ERROR");
        });
    },
    UseAamcartBalance() {
      this.aamcartBalanceUse = !this.aamcartBalanceUse;
      if (this.aamcartBalanceUse == true) {
        this.useAmmount.aamcartamount = this.wallet.txnAamcartBalance;
        this.isValid = true;
      } else {
        this.useAmmount.aamcartamount = 0;
        if (this.rewardBalanceUse == false) {
          this.isValid = false;
        }
      }
    },
    UseRewardBalance() {
      this.rewardBalanceUse = !this.rewardBalanceUse;
      if (this.rewardBalanceUse == true) {
        this.useAmmount.rewardsamount = this.rewardAmount;
        /*parseFloat(
          ((this.rewardAmount / 100) * this.getCartTotalPrice()).toFixed(1)
        );*/
        this.isValid = true;
      } else {
        this.useAmmount.rewardsamount = 0;
        if (this.aamcartBalanceUse == false) {
          this.isValid = false;
        }
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        const marker = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        this.marker = { position: marker };
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        this.getReverseGeoCode();
      });
    },
    updateLocation(location) {
      const updatedMarker = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      };

      this.marker = {
        ...this.marker,
        position: updatedMarker
      };
    },
    drgensed() {
      this.center = this.marker.position;
      this.getReverseGeoCode();
    },
    setupFirebaseReading: function() {
      this.$bind(
        "customerAdr",
        dbFs
          .collection("customer")
          .doc(this.user.uid)
          .collection("address")
          .where("status", "==", true)
      )
        .then(() => {
          this.getCartData();
          this.getAppConfig();
          this.checkWalletAmount();
        })
        .catch(() => {})
        .finally(() => {});
    },
    getAppConfig() {
      this.$rtdbBind("appConfig", db.ref("AppSettings"))
        .then(() => {
          if (this.appConfig.deliveryCharges != undefined) {
            this.deliveryCharge = this.appConfig.deliveryCharges;
          }
          if (this.appConfig.onlinePayment != undefined) {
            this.onlinePayment = this.appConfig.onlinePayment;
          }
          if (this.appConfig.rewardAmount != undefined) {
            this.rewardAmount = this.appConfig.rewardAmount;
          }
        })
        .catch(() => {});
    },
    getAllVendor() {
      this.$bind("vendors", dbFs.collection("vendor")).catch(error => {
        console.log(error);
      });
    },
    getvendorsId() {
      this.carts.forEach();
    },
    getSellerName(id) {
      let seller = "";
      for (const cusKey of Object.keys(this.vendors)) {
        const product = this.vendors[cusKey];
        if (id == product.id) {
          seller = product.shopDetails.name;
        }
      }
      return seller;
    },
    addShowadd() {
      this.addShow = !this.addShow;
    },
    AddAddress() {
      this.addAddressloading = true;
      let add = this.address;
      dbFs
        .collection("customer")
        .doc(this.user.uid)
        .collection("address")
        .add(add)
        .catch(() => {})
        .finally(() => {
          this.Loadingtype = "success";
          this.address = {
            addressType: null,
            c_number: "",
            c_person: "",
            city: "",
            firstLine: "",
            landmark: "",
            status: true,
            latlng: { lat: 0, lng: 0 },
            pincode: "",
            secondLine: "",
            state: null
          };
          setTimeout(() => {
            this.addShow = !this.addShow;
            this.addAddressloading = false;
          }, 3000);
        });
    },
    getCartData() {
      this.$rtdbBind("carts", db.ref("carts/" + this.user.uid))
        .then(() => {
          this.carts.forEach(doc => {
            const isAvailable = this.VendorsList.find(
              prod => prod === doc.vendorId
            );
            if (isAvailable == undefined) {
              this.VendorsList.push(doc.vendorId);
            }
            dbFs
              .collection("products")
              .where("productId", "==", doc.productId)
              .limit(1)
              .get()
              .then(res => {
                res.forEach(innerdoc => {
                  var obj = {
                    id: innerdoc.id,
                    name: innerdoc.data().name,
                    image: innerdoc.data().image,
                    productId: innerdoc.data().productId,
                    unitType: innerdoc.data().unitType
                  };
                  this.products.push(obj);
                });
              });
            dbFs
              .collection("vendorProducts")
              .doc(doc.vendorProductId)
              .get()
              .then(res => {
                // res.forEach(innerdoc => {
                let data = res.data();
                var obj = {
                  id: res.id,
                  moq: data.moq,
                  mrp: data.mrp,
                  productCategoryId: data.productCategoryId,
                  productsId: data.productsId,
                  sellPrice: data.sellPrice,
                  status: data.status,
                  stock: data.stock,
                  vendorId: data.vendorId
                };
                this.vendorProducts.push(obj);
                // });
              });
          });
        })
        .catch(() => {
          this.getCartData();
        });
    },
    getProduct(id, dataType) {
      let productDetails = {
        name: "Not Found",
        unitType: "",
        image: ""
      };
      for (const cusKey of Object.keys(this.products)) {
        const product = this.products[cusKey];
        if (id == product.id) {
          productDetails = product;
        }
      }
      if (dataType == "name") {
        return productDetails.name;
      }
      if (dataType == "unitType") {
        return productDetails.unitType;
      }
      if (dataType == "image") {
        return productDetails.image;
      }
    },
    getVendorProduct(id, dataType) {
      let productDetails = "";
      for (const cusKey of Object.keys(this.vendorProducts)) {
        const product = this.vendorProducts[cusKey];
        if (id == product.id) {
          productDetails = product;
        }
      }
      if (dataType == "sellprice") {
        return productDetails.sellPrice;
      }
      if (dataType == "stock") {
        return productDetails.stock;
      }
      if (dataType == "moq") {
        return productDetails.moq;
      }
      if (dataType == "vendorId") {
        return productDetails.vendorId;
      }
    },
    addToCart,
    RemoveProduct(vendorProductId) {
      this.StockCheck = true;
      db.ref("carts/" + this.user.uid + "/" + vendorProductId).remove();
    },
    getCartTotalPrice() {
      let total = 0;
      this.carts.forEach(cart => {
        total += cart.price;
      });
      this.totalAmount = total;
      return total;
    },
    CheckForOrder() {
      if ((this.PaymentMode != null) & (this.selectedAdr != null)) {
        return false;
      } else {
        return true;
      }
    },
    getSelectedAdr(id) {
      this.customerAdr.forEach(ard => {
        if (ard.id == id) {
          return ard;
        } else {
          return "NOt Found";
        }
      });
    },
    gettotalafterdiscount() {
      const total = this.getCartTotalPrice();
      const deliveryCharge = this.deliveryCharge;
      const aamcartamount = this.useAmmount.aamcartamount;
      const rewardsamount = this.useAmmount.rewardsamount;
      let finalTotal = 0;
      let coupon = 0;
      if (this.coupontype === "CashBack") {
        var y = this.couponValue;
        y = y.toFixed(2);
        y = parseFloat(y);
        this.discountedPrice = this.couponValue;
        coupon = y;
      }
      if (this.coupontype === "Coupon") {
        var x = (this.getCartTotalPrice() * this.couponValue) / 100;
        x = x.toFixed(2);
        x = parseFloat(x);
        this.discountedPrice =
          (this.getCartTotalPrice() * this.couponValue) / 100;
        coupon = x;
      }
      if (this.aamcartBalanceUse) {
        //aamcart main balance
        if (this.rewardBalanceUse) {
          finalTotal =
            total - coupon - rewardsamount + deliveryCharge - aamcartamount;
        } else {
          finalTotal = total - coupon + deliveryCharge - aamcartamount;
        }
      }
      if (this.rewardBalanceUse) {
        //reward balance
        if (this.aamcartBalanceUse) {
          finalTotal =
            total - coupon - rewardsamount + deliveryCharge - aamcartamount;
        } else {
          finalTotal = total - coupon - rewardsamount + deliveryCharge;
        }
      }
      if (!this.rewardBalanceUse && !this.aamcartBalanceUse) {
        finalTotal = total - coupon + deliveryCharge;
      }
      this.totalAmount = finalTotal - deliveryCharge;
      return finalTotal;
    },
    getDeliveryAdr() {
      let address = null;
      this.customerAdr.forEach(adr => {
        if (adr.id == this.selectedAdr) {
          // console.log(adr);
          address = adr;
        }
      });
      return address;
    },
    PlaceOrder() {
      // let adr = this.getDeliveryAdr();
      if (this.carts.length > 0)
        if ((this.PaymentMode == null) & (this.selectedAdr == null)) {
          this.$bvToast.toast(`Select Address Or Payment Method`, {
            title: "Error",
            variant: "danger",
            autoHideDelay: 2000
          });
        } else {
          this.Orderloading = true;
          this.loading = "loading";
          this.loadingMsg = "Confirming Payment";
          if (this.couponValue === "") {
            this.discountedPrice = 0;
          }
          if (this.PaymentMode == "COD") {
            let deliveryCharge = parseFloat(this.deliveryCharge);
            let orderAmount = parseFloat(this.totalAmount).toFixed(2);
            let orderdata = {
              discountprice: this.discountedPrice,
              couponId: this.couponid,
              orderAmount: orderAmount,
              rewardAmount: this.useAmmount.rewardsamount,
              aamcartAmount: this.useAmmount.aamcartamount,
              createdAt: Math.round(+new Date() / 1000),
              customerAdrId: this.selectedAdr,
              deliveryAddress: this.getDeliveryAdr(this.selectedAdr),
              customerId: this.user.uid,
              delveryCharges: deliveryCharge,
              orderStatus: false,
              payment: {
                txnId: "COD",
                type: this.PaymentMode,
                status: true
              },
              vendorId: this.VendorsList
            };
            dbFs
              .collection("order")
              .doc(this.OrderId)
              .set(orderdata)
              .then(() => {
                let orderCount = 0;
                this.VendorsList.forEach(onevendor => {
                  let products = [];
                  let vendorId = onevendor;
                  products = [];
                  this.carts.forEach(cart => {
                    if (vendorId == cart.vendorId) {
                      let price = parseFloat(cart.price);
                      let qty = parseFloat(cart.qty);
                      products.push({
                        createdAt: cart.createdAt,
                        price: price,
                        qty: qty,
                        productId: cart.productId,
                        vendorProductId: cart.vendorProductId
                      });
                    }
                  });
                  let bucketData = {
                    product: products,
                    status: [
                      {
                        createdAt: Math.round(+new Date() / 1000),
                        type: "0",
                        updateBy: this.user.uid
                      }
                    ]
                  };
                  dbFs
                    .collection("order")
                    .doc(this.OrderId)
                    .collection("vendor")
                    .doc(vendorId)
                    .set(bucketData)
                    .then(() => {
                      products = [];
                      orderCount = orderCount + 1;
                      if (orderCount == this.VendorsList.length) {
                        updateWallet(
                          this.OrderId,
                          this.useAmmount.rewardsamount,
                          this.wallet.txnRewardsBalance,
                          this.useAmmount.aamcartamount,
                          this.wallet.txnAamcartBalance,
                          this.user.uid
                        ).then(() => {
                          this.UpdateProducts(this.OrderId);
                        });
                      }
                    });
                });
              })
              .catch(() => {
                dbFs
                  .collection("order")
                  .doc(this.OrderId)
                  .delete();
              });
          } else {
            let deliveryCharge = parseFloat(this.deliveryCharge);
            let orderAmount = parseFloat(this.totalAmount).toFixed(2);
            let orderdata = {
              createdAt: Math.round(+new Date() / 1000),
              customerAdrId: this.selectedAdr,
              deliveryAddress: this.getDeliveryAdr(this.selectedAdr),
              customerId: this.user.uid,
              delveryCharges: deliveryCharge,
              orderAmount: orderAmount,
              rewardAmount: this.useAmmount.rewardsamount,
              aamcartAmount: this.useAmmount.aamcartamount,
              orderStatus: false,
              payment: {
                txnId: "Online",
                type: this.PaymentMode
              },
              vendorId: this.VendorsList
            };
            dbFs
              .collection("order")
              .doc(this.OrderId)
              .set(orderdata)
              .then(() => {
                let orderCount = 0;
                this.VendorsList.forEach(onevendor => {
                  let products = [];
                  let vendorId = onevendor;
                  products = [];
                  this.carts.forEach(cart => {
                    if (vendorId == cart.vendorId) {
                      let price = parseFloat(cart.price);
                      let qty = parseFloat(cart.qty);
                      products.push({
                        createdAt: cart.createdAt,
                        price: price,
                        qty: qty,
                        productId: cart.productId,
                        vendorProductId: cart.vendorProductId
                      });
                    }
                  });
                  let bucketData = {
                    product: products,
                    status: [
                      {
                        createdAt: Math.round(+new Date() / 1000),
                        type: "0",
                        updateBy: this.user.uid
                      }
                    ]
                  };
                  dbFs
                    .collection("order")
                    .doc(this.OrderId)
                    .collection("vendor")
                    .doc(vendorId)
                    .set(bucketData)
                    .then(() => {
                      updateWallet(
                        this.OrderId,
                        this.useAmmount.rewardsamount,
                        this.wallet.txnRewardsBalance,
                        this.useAmmount.aamcartamount,
                        this.wallet.txnAamcartBalance,
                        this.user.uid
                      ).then(() => {
                        this.UpdateStock(this.OrderId);
                        products = [];
                        orderCount = orderCount + 1;
                        if (orderCount == this.VendorsList.length) {
                          let total = this.totalAmount + this.deliveryCharge;
                          // let address = this.getSelectedAdr(this.selectedAdr);
                          let name =
                            this.user.displayName == null
                              ? this.user.displayName
                              : "Unknown";
                          let number =
                            this.user.phoneNumber == null
                              ? this.user.phoneNumber
                              : "7777777777";
                          let email =
                            this.user.email == null
                              ? this.user.email
                              : "test@email.com";
                          axios({
                            url:
                              "https://us-central1-aamcart-ecommerce.cloudfunctions.net/OnlinePayment",
                            method: "post",
                            data: {
                              name: name,
                              email: email,
                              mobile: number,
                              amount: total.toString(),
                              orderid: this.OrderId
                            }
                          }).then(response => {
                            this.info = response;
                          });
                        }
                      });
                    });
                });
              })
              .catch(() => {
                dbFs
                  .collection("order")
                  .doc(this.OrderId)
                  .delete();
              });
          }
        }
      else {
        this.$bvToast.toast(`Cart Empty Please Add Product`, {
          title: "Error",
          variant: "danger",
          autoHideDelay: 2000
        });
      }
    },
    UpdateProducts(id) {
      dbFs
        .collection("order")
        .doc(id)
        .update({
          orderStatus: true
        })
        .then(() => {
          this.UpdateStock(id);
          this.Loadingtype = "success";
          this.loadingMsg = "Order Success";
          setTimeout(() => {
            router.push("/user/orders");
            this.Orderloading = false;
            this.RemoveCart();
          }, 4000);
        })
        .catch(() => {
          this.Loadingtype = "error";
          this.loadingMsg = "Somting Error";
          setTimeout(() => {
            this.Orderloading = false;
          }, 4000);
        });
    },
    RemoveCart() {
      db.ref("carts/" + this.user.uid).remove();
    },
    UpdateStock(orderId) {
      dbFs
        .collection("order")
        .doc(orderId)
        .collection("vendor")
        .get()
        .then(bucketSnapShot => {
          bucketSnapShot.forEach(doc => {
            doc.data().product.forEach(prod => {
              const qty = parseFloat(prod.qty);
              const vendorProductId = prod.vendorProductId;
              dbFs
                .collection("vendorProducts")
                .doc(vendorProductId)
                .get()
                .then(vendorProductSnapshot => {
                  const curStock = parseFloat(
                    vendorProductSnapshot.data().stock
                  );
                  const updateStock = curStock - qty;
                  this.updateVendorStock(vendorProductId, updateStock);
                });
            });
          });
        })
        .catch(err => {
          console.log("Error getting documents", err);
        });
    },
    updateVendorStock(vendorProductId, updatedstock) {
      let Curstock = parseFloat(updatedstock);
      dbFs
        .collection("vendorProducts")
        .doc(vendorProductId)
        .update({
          stock: Curstock
        })
        .catch(() => {});
    },
    getPriceChangeStockDetails(product) {
      const isTrue = this.vendorProducts.find(
        prod =>
          prod.productsId === product.productId &&
          prod.stock >= product.qty &&
          prod.sellPrice === product.price / product.qty
      );
      // // if (isTrue === undefined) {
      // //   this.StockCheck = false;
      // // }

      // if (isTrue) {
      //   this.StockCheck = true;
      // }

      return isTrue;
    },
    getReverseGeoCode() {
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${
        this.marker.position.lat
      },${
        this.marker.position.lng
      }&sensor=true&key=AIzaSyABMQJLZkns8-CdR0zwdYw6Fm8a7FRBjpI`;

      this.address.latlng = {
        lat: this.marker.position.lat,
        lng: this.marker.position.lng
      };

      axios
        .get(url)
        .then(res => {
          const addressComp = res.data.results[0].address_components;
          this.address = {
            ...this.address,
            firstLine:
              addressComp[0].long_name + " " + addressComp[1].long_name,
            state: addressComp[addressComp.length - 3].long_name,
            pincode: addressComp[addressComp.length - 1].long_name,
            city: addressComp[addressComp.length - 5].long_name
          };
          this.selectedAddress = res.data.results[0].formatted_address;
        })
        .catch(err => {
          console.log(err);
        });
      this.$refs["my-modal"].hide();
    },
    checkWalletAmount() {
      this.totalAmount;
    }
  },
  watch: {
    info: () => {
      setTimeout(() => {
        document.querySelector("#payment-btn").click();
      }, 1000);
    },
    carts() {
      if (this.rewardBalanceUse) {
        this.rewardBalanceUse = false;
        this.UseRewardBalance();
      }
    }
  }
};
</script>

<style>
.bad {
  margin-top: 10px;
  box-sizing: border-box;
  padding: 10px;
}
.btn-custom {
  width: 100%;
  border-radius: 30px;
}
/* Hide the browser's default radio button */
.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.checkbox:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.checkbox input:checked ~ .checkmark {
  background-color: #f69325;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.checkbox .checkmark:after {
  top: 9px;
  left: 9px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}

.in {
  border: none;
  border-bottom: 1px solid rgb(165, 165, 165);
}
.in:focus {
  border: none;
}
.custom-pos {
  position: fixed;
  top: 0;
  right: 0;
  margin-top: 100px;
  margin-right: 9%;
  max-width: 380px;
}
@media only screen and (max-width: 1300px) {
  .custom-pos {
    position: relative;
    margin-top: 10px;
  }
}
</style>
